import axios from "axios";
import { IBookingsApiFilter } from "../types";

interface IDownloadBookingsParams {
    filters?: IBookingsApiFilter,
    fields: {
        field: string,
        headerName: string
    }[]
}

interface IDownloadBookingsReturn {
    file: any,
    fileName: string
}

export const downloadBookings = async (params: IDownloadBookingsParams): Promise<IDownloadBookingsReturn> => {
    const response = await axios.post(
        '/booking/search/basicexport',
        params,
        {
            responseType: 'blob'
        }
    );
    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition.match(/filename="(.*)"/)?.[1] ?? 'unknown';
    return {
        file: response.data,
        fileName
    };
};